// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/" + chunkId + "." + {"381": "fa71336f","944": "480e8212",}[chunkId] + ".css"
}